import React from 'react'
import { useMutation } from '@tanstack/react-query'
import { Modal } from '../../../../../components/common/Modal'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { ModalHeader } from '../../../../../components/common/Modal/ModalHeader'
import { ModalBody } from '../../../../../components/common/Modal/ModalBody'
import { ChangeUserEmailModalContent } from './ChangeUserEmailModalContent'
import { useToastNotifications } from '../../../../../hooks/useToastNotification'
import { ToastType } from '../../../../../components/common/Toast/toast-type'
import { Spinner } from '../../../../../components/common/Spinner'
import { changeUserEmail } from '../../../../../api/admin'
import { IUserModel } from '../../../../../interfaces/models/users.interfaces'

interface ChangeUserEmailModalProps {
  show: boolean
  close: () => void
  resetSearchResult: () => void
  user: IUserModel
}

export const ChangeUserEmailModal = ({
  show,
  close,
  user,
  resetSearchResult,
}: ChangeUserEmailModalProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { setToastNotification } = useToastNotifications()

  const { mutate: mutateChangeUserEmail, isPending: isChangingUserEmail } =
    useMutation({
      mutationFn: changeUserEmail,
      onSuccess: () => {
        resetSearchResult()
        close()
        setToastNotification(ToastType.SUCCESS, 'Mejladress uppdaterad')
      },
      onError: () => {
        setToastNotification(
          ToastType.DANGER,
          translate('flashMessage.somethingWentWrongError')
        )
      },
    })

  const onSubmit = async (newUserEmail: string): Promise<void> => {
    mutateChangeUserEmail({ userId: user._id, newUserEmail })
  }

  return (
    <Modal show={show}>
      {{
        header: <ModalHeader onClose={close}>Uppdatera mejladress</ModalHeader>,
        body: (
          <ModalBody className="overflow-y-auto">
            {isChangingUserEmail ? (
              <Spinner />
            ) : (
              <ChangeUserEmailModalContent
                onSubmit={onSubmit}
                onClose={close}
                user={user}
              />
            )}
          </ModalBody>
        ),
      }}
    </Modal>
  )
}
